import list from '@/components/addressBook/list'
let routes = [
    {
      path: '/addressBook',
      name: 'addressBook',
      component: list,
      meta: {
        requiresAuth: true
      }
    }
  ]
export default { routes }


// WEBPACK FOOTER //
// ./src/router/addressBook.js